import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import classes from './Team.module.css';

const Team = ({ darkMode, lessonIdProp, data }) => {

    const { texts } = useSelector(state => state.translate);
    const { user } = useSelector(state => state.auth);
    const [team, setTeam] = useState();

    const { id, guid, studyGroupId, lessonId } = useParams();

    useEffect(() => {
        if (user?.id && (id || studyGroupId)) {
            setTeam(data);
        }
    }, [id, guid, studyGroupId, lessonId, lessonIdProp, user]);


    useEffect(() => {
        if (data) {
            setTeam(data);
        }
    }, [data])

    return (
        team ?
            <div className={`${classes.Team} ${darkMode ? classes.DarkModeTeam : ''}`}>
                <div className={classes.TeamName}>{team.name || team?.user.name}:</div>
                <div className={classes.TeamMembers}>{team.user?.users?.map(s => s.id === user.id ? texts.me : s.firstName + ' ' + s.lastName).join(', ')}</div>
            </div> : ''
    )
}

export default Team;